export const Input = ({
  type = 'text',
  label,
  id,
  className = '',
  register,
  ...rest
}) => {
  if (type === 'textarea') {
    return (
      <textarea
        className={` min-h-[200px] w-full rounded-6 bg-[#F0F0F0] px-14 py-20 text-11 uppercase leading-100 text-midGray placeholder-midGray md:px-20 md:py-26 ${className}`}
        placeholder={label?.toUpperCase()}
        id={id}
        {...register(`${id}`)}
      />
    )
  }
  return (
    <input
      className={` w-full rounded-6 bg-[#F0F0F0] px-14 py-20 text-11 uppercase leading-100 text-midGray placeholder-midGray md:px-20 md:py-26 ${className}`}
      type={type}
      placeholder={label?.toUpperCase()}
      id={id}
      {...register(`${id}`)}
      {...rest}
    />
  )
}
